<template>
    <div class="transferWrap clearfix">
        <a href="https://n.allfootballapp.com/v2/transfer?id=1">
            <p>
                <span class="latest">
                    <img src="../assets/home/home_icon4.jpg" alt="Latest Transfers" title="">
                </span>
                <b>Latest</b>
            </p>
        </a>
        <a href="https://n.allfootballapp.com/v2/transfer?id=2" class="topwrap">
            <p class="top_border">
            <span class="top">
                <img src="../assets/home/home_icon2.png" alt="TOP Transfers" title="">
            </span>
                <b>TOP Transfers</b>
            </p>
        </a>
        <a href="https://n.allfootballapp.com/v2/transfer?id=3"><p><span class="rumour"><img
            src="../assets/home/home_icon3.png" alt="Transfers Rumours" title=""></span><b>Rumours</b></p></a>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'transferEntrance',
    };
</script>

<style lang="less">
    .transferWrap {
        width: 100%;
        height: 2.6rem;
        border-bottom: .01rem solid #eff1f4;
    }

    .transferWrap a {
        width: 31%;
        display: block;
        float: left;
        height: 2.6rem;
        position: relative;
    }

    .topwrap {
        width: 38% !important;
    }

    .transferWrap span {
        display: inline-block;
        width: 1.4rem;
        height: 1.4rem;
        margin: 0 .4rem 0 .3rem;
        float: left;
    }

    .transferWrap b {
        height: 1rem;
        line-height: 1.5rem;
        display: inline-block;
        color: #2d2f32;
        font-size: .8rem;
        font-weight: normal;
    }

    .transferWrap p {
        height: 1.5rem;
        margin-top: .5rem;
    }

    .latest {
        margin: 0 .5rem 0 1rem !important;
    }

    .top {
        width: 40%;
    }

    .rumour {
        margin: 0 .5rem 0 1rem !important;
    }

    .top_border {
        border-left: 1px solid #eff1f4;
        border-right: 1px solid #eff1f4;
        padding: 0 0.2rem;
        box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// transferEntrance.vue?6979b876